import { MarginProps, margin, WidthProps, width, HeightProps, height, BorderProps, border } from 'styled-system';
import styled from 'styled-components';

type ArrowComponentProps = {
  isUp: boolean;
  title?: string;
  tabIndex?: number;
} & MarginProps &
  HeightProps &
  WidthProps;

export function ArrowContainer({ isUp, ...otherProps }: ArrowComponentProps) {
  return (
    <Container
      borderStyle="solid"
      borderColor="secondary.1"
      borderWidth="0px"
      borderRightWidth="3px"
      borderTopWidth="3px"
      rotate={isUp ? '315deg' : '135deg'}
      role="button"
      aria-label={otherProps?.title}
      {...otherProps}
    ></Container>
  );
}

type ContainerProps = {
  rotate?: string;
} & MarginProps &
  WidthProps &
  HeightProps &
  BorderProps;

const Container = styled.div<ContainerProps>(
  margin,
  width,
  height,
  border,
  (props) => ({
    rotate: props.rotate,
  }),
  {
    outlineWidth: '0px',
  }
);
